/**
 * PolicySignatureService
 * Service for PolicySignature entity operations
 * Route: api/policysignatures
 */
import { CrudService } from '../base/CrudService';
/**
 * PolicySignatureService
 * Handles policy signature CRUD operations
 */
export class PolicySignatureService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PolicySignatureService.DEFAULT_SERVICE_PATH,
            basePath: PolicySignatureService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
PolicySignatureService.DEFAULT_SERVICE_PATH = 'hr';
PolicySignatureService.BASE_PATH = 'api/policysignatures';
//# sourceMappingURL=PolicySignatureService.js.map